$('#single_picker').daterangepicker({
    singleDatePicker: true,
    singleClasses: "picker_3",
    locale: {
        format: 'DD-MM-YYYY'
      }
}, function(start, end, label) {
    console.log("A new date selection was made: " + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD'));
});

$('.select2').select2({
    minimumResultsForSearch: -1
});

$('b[role="presentation"]').hide();
$('.select2-selection__arrow').append('<i class="fa fa-angle-down"></i>');